export const endpoint = "https://ativacao.midiasimples.com.br";



// WEBPACK FOOTER //
// ./src/helpers/constantes.js